module.exports = __webpack_public_path__ + "img/logo-fifalotto-white44-ufo711.8158827f.png";